import offerTable from './offerTable';

export default offerTable;
